<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: "game-record",
  
})
</script>
<template>
    <div class="game-record-page">
        <!-- 页面导航栏 -->
        <ComPageHeader title="menu_game_record" @close="handleBack" />

        <!-- 游戏记录内容 -->
        <div class="record-wrap">
            <div class="record-title">
                <p v-for="(item, index) in tab" :key="index">{{ $t(`${item}`) }}</p>
            </div>
            <div class="record-content">
                <ScrollList
                    ref="scroll"
                    class="record-content-scroll"
                    :api="getList"
                    :disableRefresh="false"
                    :showFinishText="false"
                    @onChange="getRecordList"
                >
                    <template #default>
                        <template v-if="recordList.length > 0">
                            <div class="record-data-container">
                                <div class="record-item" v-for="item in recordList" :key="item._id || item._source?.SettlementTime">
                                    <div>
                                        <p class="compact-p">{{ item._source.gamename }}</p>
                                        <p class="compact-p">
                                            {{ dayjs(item._source.SettlementTime).format('YYYY-MM-DD HH:mm:ss') }}
                                        </p>
                                    </div>
                                    <p style="color: rgb(0, 168, 255); font-size: 12px">
                                        {{ store.curSymbol[item._source.currency] }} {{ formatNumber(item._source.BetAmount) }}
                                    </p>
                                    <!-- <p>{{ item._source.PayoffAmount + item._source.BetAmount > 0 ? $t('Win') : $t('Lose') }}</p> -->
                                    <p v-if="item._source.PayoffAmount > 0" style="color: rgb(37, 223, 130)">
                                        {{ store.curSymbol[item._source.currency] }}
                                        {{ formatNumber(item._source.PayoffAmount) }}
                                    </p>
                                    <p v-else style="color: rgb(153, 167, 178)">
                                        {{ store.curSymbol[item._source.currency] }}
                                        {{ formatNumber(item._source.PayoffAmount) }}
                                    </p>
                                </div>
                            </div>
                        </template>
                        <van-empty class="empty-tip" v-else :image="NoDataImg" :description="$t('No_game_record')"></van-empty>
                    </template>
                </ScrollList>
            </div>
        </div>
    </div>
</template>
<script lang="ts" setup name="game-record">
import ScrollList from '@/components/ScrollList.vue'
import ComPageHeader from '@/components/common/ComPageHeader.vue'
import { getGameRecords } from '@/api/wallet'
import dayjs from 'dayjs'
import { formatNumber, formatNormalNumber } from '@/utils/toolsValidate'
import { useBaseStore } from '@/stores'
import { useRouter } from 'vue-router'
import NoDataImg from '@/assets/img/wallets/no_data.png'

const store = useBaseStore()
const router = useRouter()
const isEmpty = ref(false)
const scroll = ref(null)

// 返回上一页
const handleBack = () => {
    router.back()
}

const getList = async (params) => {
    const { page, pageSize } = params

    try {
        const res = await getGameRecords(
            {
                from: (page - 1) * pageSize,
                size: pageSize,
            },
            false
        )

        if (res.code === 200) {
            isEmpty.value = res.data.total.value === 0
            return res.data.hits
        } else {
            return []
        }
    } catch (e) {
        return []
    }
}

const tab = ['Game', 'Bet', 'Win']
const recordList = ref([])
const getRecordList = (list, state) => {
    recordList.value = state.reset ? [...list] : [...recordList.value, ...list]
}

onActivated(() => {
    scroll.value && scroll.value.refresh()
})
</script>
<style lang="scss" scoped>
// 页面级样式
.game-record-page {
    min-height: calc(var(--vh, 1vh) * 100);
    background-color: #232626;
}

.record-wrap {
    height: calc(var(--vh, 1vh) * 100 - var(--home-header));
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.record-title {
    margin-top: 27.9122px;
    margin-left: 27px;
    margin-right: 27px;
    padding: 20.9341px 27.9122px;
    background-color: #292d2e;
    border-radius: 20.9341px 20.9341px 0px 0px;

    display: flex;
    justify-content: space-between;
    align-items: center;

    p {
        flex: 1;
        font-size: 25px;
        font-weight: 600;
        color: #ffffff;
    }

    /* Game 左对齐 */
    p:nth-child(1) {
        text-align: left;
    }

    /* Bet 和 Win 右对齐 */
    p:nth-child(2),
    p:nth-child(3) {
        text-align: right;
    }
}

.record-content {
    flex: 1;
    overflow: hidden;
    padding: 0;
    position: relative;
}

.record-content-scroll {
    height: 100%;
    overflow: auto;
    padding-left: 27px;
    padding-right: 27px;
}

.record-data-container {
    background-color: #323738;
    border-radius: 0 0 20.9341px 20.9341px;
}

.record-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    min-height: 115px;
    padding: 20px 13.9561px;
    border-bottom: 1px solid rgb(41, 45, 46); /* 底部细线 */

    /* 最后一行不显示底部边框 */
    &:last-child {
        border-bottom: none;
    }

    /* 第二列和第三列（Bet、Win）右对齐 */
    > p:nth-child(2),
    > p:nth-child(3) {
        flex: 1;
        color: #ffffff;
        display: flex;
        align-items: center;
        justify-content: flex-end;
    }

    > p:nth-child(3) {
        font-size: 22px;
        font-weight: bolder;
    }

    /* 第一列（游戏名称）左对齐 */
    > div:first-child {
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
        gap: 4px; /* 添加垂直间距 */

        /* 游戏名称和时间戳的通用样式 */
        .compact-p {
            margin: 0;
            text-align: left;
            word-break: break-word;
        }

        /* 游戏名称样式（第一个 p 标签）*/
        .compact-p:first-child {
            font-size: 24px;
            font-weight: 600;
            color: #ffffff;
        }

        /* 时间戳样式（最后一个 p 标签）*/
        .compact-p:last-child {
            font-size: 20px;
            color: #afb7ba;
            white-space: nowrap;
            font-weight: 400; /* 时间戳用正常字重 */
        }
    }
}

.empty-tip {
    text-align: center;
}

:deep(.van-empty) {
    padding-top: 240px; // 添加顶部间距

    .van-empty__image {
        width: 308px;
        height: 113px;
        opacity: 0.6;

        img {
            object-fit: contain;
        }
    }
}

:deep(.van-list) {
    padding-bottom: calc(40px + constant(safe-area-inset-bottom));
    padding-bottom: calc(40px + env(safe-area-inset-bottom));
}
</style>
